module.exports = __webpack_public_path__ + "static/audical-f78c9fceff7b0bb7c38b281faa6f4f61.jpg";